import { render, staticRenderFns } from "./DataEstudiante.vue?vue&type=template&id=4f67d2e6"
import script from "./DataEstudiante.vue?vue&type=script&lang=js"
export * from "./DataEstudiante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports